import { createSlice } from "@reduxjs/toolkit";

const initialState =  { time: 60, timeForProgress: 1, progress: null };

const wordTimeSlice = createSlice({
  name: "wordTimeSlice",
  initialState,
  reducers: {
    DecreaseTime: (state, action) => {
      state.time= state.time - 1;
      return state;
    },
    ResetTime: (state, action) => {
      state.time = 60;
      return state;
    },
    IncreaseTimeForProgress: (state, action) => {
      state.timeForProgress = state.timeForProgress + 1;
      return state;
    },
    ResetTimeForProgress: (state, action) => {
      state.timeForProgress = 1;
      return state;
    },
    SetProgress: (state, action) => {
      // state.progress = -1 * (state.timeForProgress * (100/30) - 100);
      state.progress = -1 * (state.timeForProgress * (100/60) - 100);
      return state;
    },
  },
});
export const {
  DecreaseTime,
  ResetTime,
  IncreaseTimeForProgress,
  ResetTimeForProgress,
  SetProgress,
} = wordTimeSlice.actions;
export default wordTimeSlice;